import Vue from "vue"
import * as sanitizeHtml from 'sanitize-html';

Vue.directive("clean-html", {
	bind: function (el, binding, vnode) {
		el.innerHTML = sanitizeHtml(binding.value);
	}
});